import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import React, { PureComponent } from "react";
import classnames from "classnames";
import { parseText, getOnMountHandlers, getOnUnmountHandlers } from "client/services/monday-markup-language/monday-markup-language-service";
import { withGenericConfig } from "contexts/generic-config-context";
class MondayMarkupLanguageComponent extends PureComponent {
    componentDidMount() {
        getOnMountHandlers().forEach((handler)=>{
            handler(this.ref.current);
        });
    }
    componentWillUnmount() {
        getOnUnmountHandlers().forEach((handler)=>{
            handler(this.ref.current);
        });
    }
    render() {
        const { tagName: CustomTag, text, className, style, localeId } = this.props;
        if (!text) return null;
        const parsedText = parseText(text, localeId);
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(CustomTag, {
                    ref: this.ref,
                    dangerouslySetInnerHTML: {
                        __html: parsedText
                    },
                    style: style,
                    className: "jsx-d5ab030c0026806b" + " " + (classnames("monday-markup-language-component", className) || "")
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: "d5ab030c0026806b",
                    children: ".monday-markup-language-component a{text-decoration:underline}"
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.ref = /*#__PURE__*/ React.createRef();
    }
}
MondayMarkupLanguageComponent.defaultProps = {
    tagName: "div"
};
export default withGenericConfig(MondayMarkupLanguageComponent);
